import { Controller } from "@hotwired/stimulus"

// Add/remove rows in a list field (schedule events, FAQs, gift links). New
// rows come from a <template> whose field names contain NEW_ROW, replaced
// with a unique index so Rails receives them as items[<index>][field].
export default class extends Controller {
  static targets = ["list", "template", "row", "addButton"]
  static values = { max: Number }

  connect() {
    this.toggleAdd()
  }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_ROW", Date.now().toString())
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.rowTargets.at(-1)?.querySelector("input, textarea")?.focus()
    this.toggleAdd()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-nested-rows-target='row']")
    const previous = row.previousElementSibling
    row.remove()
    ;(previous?.querySelector("input, textarea") || this.addButtonTarget).focus()
    this.toggleAdd()
  }

  toggleAdd() {
    if (!this.hasAddButtonTarget || !this.maxValue) return
    this.addButtonTarget.hidden = this.rowTargets.length >= this.maxValue
  }
}
